import {Link, NavLink} from 'react-router-dom';

import { HiChevronDoubleUp, HiChevronDoubleDown } from 'react-icons/hi';

import React, { useState } from 'react'

import './index.scss'
import LogoS from '../../../assets/images/logo-s.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faEnvelope, faHome, faUser } from '@fortawesome/free-solid-svg-icons';
import { faBehance,    faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons';




function Sidebar() {
    const [showLinks , setShowlinks] = useState(false)
    
  return (

    
    <div className={showLinks ? 'nav-bar show-toggle' : 'nav-bar'}>


        <Link className='logo' to='/'>
            <img src={LogoS} alt="" />
  
        </Link>
<nav>


    <Link   className='active' to='/'>
    <FontAwesomeIcon icon={faHome} color='#4d4d4e'/>
        </Link>


        <Link   className='about-link' to='/about'>
            <FontAwesomeIcon icon={faUser} color='#4d4d4e'/>
        </Link>
        <Link   className='contact-link' to='/contact'>
    <FontAwesomeIcon icon={faEnvelope} color='#4d4d4e'/>

        </Link>



</nav>

<ul>
    <li>
        <a href="https://www.linkedin.com/in/sami-kamran-passionate-to-craft-exceptional-user-experiences-155809257/" target='_blank' >
    <FontAwesomeIcon icon={faLinkedin} color='#4d4d4e'/>

        </a>
    </li>
    <li>
        <a href="https://www.behance.net/samikamran" target='_blank' >
    <FontAwesomeIcon icon={faBehance} color='#4d4d4e'/>

        </a>
    </li>
    <li>
        <a href="https://youtu.be/SC-41Iue2TE?si=aIc26i6BMFEB8hmX" target='_blank' >
    <FontAwesomeIcon icon={faYoutube} color='#4d4d4e'/>

        </a>
    </li>
    <li>
        <a href="https://www.linkedin.com/feed/" target='_blank' >
            
  

        </a>
    </li>
</ul>
      
      <button onClick={()=>setShowlinks(!showLinks)} className='button-heelo'>
      {showLinks ? <HiChevronDoubleUp/>

: <HiChevronDoubleDown/>
}


      </button>
    </div>
  )
}

export default Sidebar
